import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MatCardModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Winning Hands App';

  //constructor(private router: Router) {

  //  // Successful route changes
  //  this.router.events
  //    .pipe(
  //      filter(event => event instanceof NavigationEnd)
  //    )
  //    .subscribe((event: any) => {
  //      console.log('Route changed:', event);
  //    });

  //  // Optional: log everything
  //  this.router.events.subscribe(event => {
  //    console.log(event);
  //  });

  //}

}
